import { InvitesState } from './invites.types'

export default (): InvitesState => ({
  data: {},
  filters: {}
})
